export const ERROR_ESIA_POPUP_MESSAGE_DELAY = 5000;

export const PARTNERS_IDS_WITH_ESIA_FEATURE = [] as number[];
